import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { FilterView } from './view';

export const Filter = ({
    headline,
    options,
    filter,
    properties,
    setFilter,
    isBestseller,
    isFavorite
}) => {
    const [isVisible, setVisibility] = useState(false);

    const toggleVisibility = () => {
        setVisibility((previousVisibility) => (!previousVisibility));
    };

    useEffect(() => {
        setVisibility(Boolean(properties.size));
    }, [properties]);

    return (
        <FilterView
            headline={ headline }
            options={ options }
            filter={ filter }
            properties={ properties }
            isVisible={ isVisible }
            setFilter={ setFilter }
            toggleVisibility={ toggleVisibility }
            isBestseller={ isBestseller }
            isFavorite={ isFavorite }
        />
    );
};

Filter.defaultProps = {
    isBestseller: false,
    isFavorite: false
};

Filter.propTypes = {
    headline: PropTypes.string.isRequired,
    options: PropTypes.instanceOf(Array).isRequired,
    filter: PropTypes.string.isRequired,
    properties: PropTypes.instanceOf(Set).isRequired,
    setFilter: PropTypes.func.isRequired,
    isBestseller: PropTypes.bool,
    isFavorite: PropTypes.bool
};